module.exports = __webpack_public_path__ + "img/EMT-GBM_10X_WTA.82e19c31.png";